// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__S4QuS"};